module.exports = __webpack_public_path__ + "8187d28ad256d87e3c58d4dae019533f.svg";